export const verticalSettingsReducer = (state = {}) => state;
